function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
const useStyles = makeStyles(theme => ({
  reviewContainer: {
    marginTop: 16,
    backgroundColor: theme.palette.info.light,
    borderRadius: 4,
    padding: 16
  }
}));
const SummaryItem = ({
  children,
  ...rest
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.reviewContainer
  }, /*#__PURE__*/React.createElement(Typography, _extends({
    color: "textPrimary",
    align: "center",
    component: "div",
    variant: "h6"
  }, rest), children));
};
export default SummaryItem;
SummaryItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]).isRequired
};